import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'app-timer',
  templateUrl: './timer.component.html',
  styleUrls: ['./timer.component.scss'],
  providers: [DatePipe],
})
export class TimerComponent implements OnInit, OnDestroy {
  @Input() public finalDate: any;
  @Input() public diffDays: number = 0;
  @Input() public timeActivateCard: boolean = false;
  @Input() public timeActivateDays: boolean = false;
  @Input() public desafioAceito: boolean = false;
  @Input() public ajust__popup: boolean = false;
  private subscription: Subscription;

  public dateNow = new Date();
  milliSecondsInASecond = 1000;
  hoursInADay = 24;
  minutesInAnHour = 60;
  SecondsInAMinute = 60;

  public formatDays: number = 0;

  public timeDifference;
  public secondsToDday;
  public minutesToDday;
  public hoursToDday;
  public daysToDday;

  public timeActivate: boolean = false;

  constructor(private datePipe: DatePipe, private changeDetectorRef: ChangeDetectorRef) { }

  private getTimeDifference() {
    this.timeDifference = new Date(this.finalDate).getTime() - new Date().getTime();
    this.allocateTimeUnits(this.timeDifference);
    this.changeDetectorRef.detectChanges();
  }

  private allocateTimeUnits(timeDifference) {
    this.secondsToDday = Math.floor(
      (timeDifference / this.milliSecondsInASecond) % this.SecondsInAMinute
    );
    this.minutesToDday = Math.floor(
      (timeDifference / (this.milliSecondsInASecond * this.minutesInAnHour)) % this.minutesInAnHour
    );
    this.hoursToDday = Math.floor(
      (timeDifference / (this.milliSecondsInASecond * this.minutesInAnHour * this.SecondsInAMinute)) %
      this.hoursInADay
    );
    this.daysToDday = Math.floor(
      timeDifference / (this.milliSecondsInASecond * this.minutesInAnHour * this.SecondsInAMinute * this.hoursInADay)
    );
  }

  dateProcess() {
    let dateNow = this.datePipe.transform(this.dateNow, 'dd-MM-yyyy');
    let dateCard = this.datePipe.transform(this.finalDate, 'dd-MM-yyyy');

    if (dateNow === dateCard) {
      this.timeActivate = true;
      let dateTransform = this.datePipe.transform(
        this.finalDate,
        'LLL dd yyyy HH:mm:ss'
      );

      this.finalDate = new Date(dateTransform);
    } else {
      this.timeActivate = false;
    }
  }

  ngOnInit() {
    if (this.finalDate == null || this.finalDate == undefined) {
    } else {
      this.dateProcess();
      this.getTimeDifference();
      this.subscription = interval(1000).subscribe((x) => {
        this.getTimeDifference();
      });
    }
    this.formatDays = Math.floor(this.diffDays);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
